import {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react'

import useGetPollingScript from 'hooks/query/useGetPollingScript'
import { FormValues } from 'utils/type'
import { UseFormSetValue } from 'react-hook-form'

function useGenerateScriptPolling(
  extensionCollectId: number | null,
  index: number,
  setValue: UseFormSetValue<FormValues>,
  setSuccessGenerateScript: Dispatch<SetStateAction<boolean>>,
  setIsCyclingMessage: Dispatch<SetStateAction<boolean>>,
  setScriptStatus: Dispatch<SetStateAction<string | null>>
) {
  const pollCountRef = useRef(0)
  const intervalRef = useRef<NodeJS.Timeout | null>(null)
  const [isPolling, setIsPolling] = useState(false)
  const query = useGetPollingScript(extensionCollectId, isPolling)

  const stopPolling = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
    }
    setIsPolling(false)
  }, [])

  const startPolling = useCallback(() => {
    pollCountRef.current = 0

    setIsPolling(true)
    query.refetch()

    intervalRef.current = setInterval(() => {
      query.refetch().then((res) => {
        const status = res.data?.status

        console.log('🔁 polling', pollCountRef.current, status)

        if (status === 'failed') {
          console.log('스크립트 생성 실패', status)
          setValue(
            `products.${index}.userScript`,
            '대본 생성이 완료되지 않았어요. \n대본 생성하기 버튼을 다시 클릭해주세요!'
          )
          stopPolling()
          return
        }

        if (status === 'done' && res.data) {
          stopPolling()
          return
        }
      })
    }, 5000)
  }, [query.refetch, stopPolling])

  useEffect(() => {
    if (!isPolling || !query.data) return

    const { status, aiScript } = query.data
    const changeStatus = status as string
    setScriptStatus(changeStatus)

    if (status === 'done' && aiScript) {
      setValue(`products.${index}.userScript`, aiScript)
      setSuccessGenerateScript(true)
      setIsCyclingMessage(false)
      stopPolling()

      console.log('✅ 스크립트 생성 완료', query.data)
    } else if (status === 'failed') {
      setValue(
        `products.${index}.userScript`,
        '대본 생성이 완료되지 않았어요. \n대본 생성하기 버튼을 다시 클릭해주세요!'
      )
      setSuccessGenerateScript(true)
      setIsCyclingMessage(false)
      stopPolling()

      console.log('❌ 스크립트 생성 실패', query.data)
    }
  }, [query.data, isPolling])

  useEffect(() => {
    // 언마운트 시 클린업
    return () => {
      stopPolling()
      pollCountRef.current = 0
    }
  }, [stopPolling])

  return {
    ...query,
    pollCount: pollCountRef.current,
    isPolling,
    setIsPolling,
    startPolling, // ✅ 수동 시작
    stopPolling, // ✅ 수동 중지
  }
}

export default useGenerateScriptPolling
